"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObj = (object) => typeof object === 'object' && object !== null;
exports.isDate = (v) => v instanceof Date && !isNaN(v.getTime());
exports.isJSONObject = (object) => typeof object === 'object' && object !== null;
exports.isString = (v) => typeof v === 'string' || v instanceof String;
exports.isBoolean = (v) => typeof v === 'boolean';
exports.isNumber = (v) => (typeof v === 'number' || v instanceof Number) && !isNaN(Number(v));
exports.isDefined = (v) => (v !== undefined && v !== null);
exports.isValidPositiveInteger = (v) => !isNaN(Number(v)) && v >= 0 && !(v % 1);
exports.isValidPositive = (value) => !isNaN(Number(value)) && value >= 0;
exports.isPrimitiveSymbolic = (value) => exports.isNumber(value) || exports.isString(value);
/**
 *
 * @param min
 * @param max
 * @returns Random integer from the interval with min and max included
 */
exports.randomIntFromInterval = (min, max) => Math.floor(Math.random() * (max - min + 1) + min); // min and max included
exports.copyJSONObject = (obj) => JSON.parse(JSON.stringify(obj));
exports.removeSpecials = (str) => str && str.replace(/[`~!@#$%^&*()_|+\-=?;:'"<>\{\}\[\]\\\/]/gi, '');
exports.getIdFromEntityField = (entityField) => exports.isObj(entityField) ? entityField.id : entityField;
exports.getPropertyIfExists = (object, property) => property in object ? property : null;
exports.objectHasProperty = (object, property) => property in object ? true : false;
exports.getDecNumber = (num) => {
    if (isNaN(num)) {
        return 0;
    }
    const p = 100;
    return Math.round(num * p) / p;
};
exports.plus = (num1, num2) => exports.getDecNumber(exports.getDecNumber(num1) + exports.getDecNumber(num2));
exports.minus = (num1, num2) => exports.getDecNumber(exports.getDecNumber(num1) - exports.getDecNumber(num2));
exports.sleepMs = (ms) => new Promise(resolve => setTimeout(resolve, ms));
function typeormUnionBuilder(initialQueryBuilder, ...queries) {
    const stringfyQuery = (query, queryBuilder, index) => {
        const sql = `(${queryBuilder.getQuery()})`;
        // If first recursion
        if (!index) {
            return {
                getQuery: () => sql,
                getParameters: () => queryBuilder.getParameters(),
            };
        }
        // If not first recursion
        return {
            getQuery: () => `${query.getQuery()} UNION ${sql}`,
            getParameters: () => (Object.assign(Object.assign({}, queryBuilder.getParameters()), query.getParameters())),
        };
    };
    const { getQuery, getParameters } = queries.reduce(stringfyQuery, {
        getQuery: initialQueryBuilder.getQuery,
        getParameters: initialQueryBuilder.getParameters,
    });
    return {
        // Wrap final sql in parantheses to allow for table alias
        getQuery: () => `(${getQuery()})`,
        getParameters,
    };
}
exports.typeormUnionBuilder = typeormUnionBuilder;
